module.exports = __webpack_public_path__ + "static/media/my-profile-photo-example.faf100c9.svg";